/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../../../infra/hooks';
import { attendanceServices } from '../../../../api/services/attendanceServices';
import { setEmpWeekoffNTimeData } from '../../../../infra/aggregates/myProfile/AttendanceAggregates/getEmpWeekoffNTimeshiftSlice';

interface PropsValues {
  setWeekoffNTimeData: (data: any) => void;
}
function DTOWeekoffNtimeShift({ setWeekoffNTimeData }: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);
  const weekoffNTimeshift = useAppSelector(
    (state) => state.getEmpWeekoffNTimeshiftSlice.empWeekoffNTimeData,
  );

  const dispatch = useAppDispatch();
  async function getShiftData(empId: number) {
    const response: any = await attendanceServices.getWeekoffNTimeshift(empId);

    if (response.response == 'success') {
      const empWeekoffNTimeData: any = response?.data;

      dispatch(setEmpWeekoffNTimeData(empWeekoffNTimeData));

      setWeekoffNTimeData(empWeekoffNTimeData);
    }
  }
  useEffect(() => {
    getShiftData(selector.emp_id);
  }, []);

  useEffect(() => {
    setWeekoffNTimeData(weekoffNTimeshift);
  }, [weekoffNTimeshift]);

  return null;
}
export default DTOWeekoffNtimeShift;
